import { useState } from 'react';
import getDealPaymentStatuses from '../../api/deals/getDealPaymentStatuses';
import Select from '../Select/Select';

const SelectDealPaymentStatuses = ({ handleSetSelect, handleSetState, style, ...props }) => {
  // const [data, setData] = useState([]);
  // const onFocus = () => {
  //   getDealPaymentStatuses().then((res) => {
  //     const statuses = res.data.map((item) => {
  //       return { value: item.id, label: item.title };
  //     });
  //     setData(statuses);
  //   });
  // };

  const options = [
    { value: 1, label: 'ÐÐ¿Ð»Ð°ÑÐµÐ½' },
    { value: 2, label: 'ÐÐµ Ð¾Ð¿Ð»Ð°ÑÐµÐ½' },
  ];

  return (
    <Select
      handleSetSelect={(val) => handleSetSelect && handleSetSelect(val)}
      handleSetState={handleSetState}
      options={options}
      title={'Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ'}
      placeholder={'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°'}
      // onFocus={onFocus}
      style={style}
			{...props}
    />
  );
};

export default SelectDealPaymentStatuses;
